import { render, staticRenderFns } from "./hospital_details.vue?vue&type=template&id=bd2f1038&scoped=true"
import script from "./hospital_details.vue?vue&type=script&lang=js"
export * from "./hospital_details.vue?vue&type=script&lang=js"
import style0 from "./hospital_details.vue?vue&type=style&index=0&id=bd2f1038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2f1038",
  null
  
)

export default component.exports